import { DietaryButton } from 'components/cards/dietary-button';
import { CarouselRow } from 'components/carousels/carousel-row';
import { useCarousel } from 'components/carousels/CarouselController';
import { ScrollButtons } from 'components/carousels/ScrollButtons';
import { MaxWidthContainer } from 'components/city-blocks/max-width-container';
import { useRefState } from 'hooks/useRefState';
import React from 'react';
import { DietaryFilterButton } from 'utils/dietary-util';
import { CityPageFilterFragment } from 'utils/gqlReactTypings.generated.d';

const PADDING = 16;
const IS_ONSCREEN_THRESHOLD = 40;

interface IProps {
  id?: string;
  className?: string;
  title?: string;
  dietaryButtons: DietaryFilterButton[];
  activeFilter?: CityPageFilterFragment;
}

export const DietaryCarousel: React.FC<IProps> = ({ id, className, title, dietaryButtons, activeFilter }) => {
  const [ref, setRef] = useRefState<HTMLDivElement>();
  const { scrollLeft, scrollRight, hasOverflow, numElementsLeft, numElementsRight } = useCarousel(
    ref,
    dietaryButtons,
    PADDING,
    IS_ONSCREEN_THRESHOLD
  );

  if (!dietaryButtons?.length) return null;

  return (
    <MaxWidthContainer id={id} className={className}>
      {title && <h3 className='m-0 mb-6 px-4 text-2xl font-bold text-neutral-800 md:px-0 md:text-3xl'>{title}</h3>}
      <div className={`relative w-full`}>
        <CarouselRow padding={PADDING} shadowBreathingRoom={PADDING} ref={setRef}>
          {dietaryButtons.map((button) => (
            // TODO: Gil Note: De-risk href construction; it could already have an anchor in it
            //                 https://app.asana.com/0/1203388046912288/1203603261499135/f
            <DietaryButton
              key={button.href}
              href={`${button.href}${id ? `#${id}` : ''}`}
              item={button}
              active={activeFilter?.dietaryFilter === button.id}
            />
          ))}
        </CarouselRow>

        {hasOverflow && (
          <ScrollButtons
            className='absolute -top-6 right-[-60px] hidden md:flex'
            elementName='dishes-carousel-scroll-buttons'
            scrollRight={scrollRight}
            scrollLeft={scrollLeft}
            numElementsLeft={numElementsLeft}
            numElementsRight={numElementsRight}
          />
        )}
      </div>
    </MaxWidthContainer>
  );
};
